import { FlaskConical } from 'lucide-react';
import { isStaging } from '../../lib/environment';

/**
 * StagingBanner - Displays a prominent, non-dismissible banner when running in staging environment
 * 
 * This component is designed to be:
 * - Non-dismissible (no close button)
 * - Visually prominent (gradient, animation)
 * - Impossible to confuse with production
 * 
 * Shows only on staging.propellertravel.com or when VITE_ENVIRONMENT = 'staging'
 */
export function StagingBanner() {
    if (!isStaging()) return null;

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-amber-900 py-3 px-4 text-center font-bold text-sm shadow-lg select-none"
            style={{ pointerEvents: 'none' }}
        >
            <div className="flex items-center justify-center gap-3">
                <FlaskConical className="w-5 h-5 animate-pulse" />
                <span className="tracking-wider">🧪 STAGING ENVIRONMENT</span>
                <span className="text-amber-800 font-normal">
                    — This environment uses test data and is intended for automated and agentic testing.
                </span>
                <FlaskConical className="w-5 h-5 animate-pulse" />
            </div>
        </div>
    );
}
